
import { mapGetters } from 'vuex'
import { commonfunc } from '~/mixin/common'
import Matrial from '@/components/ds/common/Material.vue'
import * as ds from '~/scriptData/ds/dsCommon'
import SCR_DSA_0027 from '@/components/ds/dsa/SCR_DSA_0027.vue' // 전시 카테고리 컴포넌트
import SCR_DSE_0005 from '@/components/ds/dse/SCR_DSE_0005.vue' // 장바구니 구좌 컴포넌트
import SCR_DSM_0027 from '@/components/ds/dsm/SCR_DSM_0027.vue' // 묶음상품 구좌 컴포넌트
import { groobeeUtil } from '@/mixin/groobeeUtil'

export default {
  name: 'ACCOUNT',
  components: {
    Matrial,
    SCR_DSA_0027,
    SCR_DSE_0005,
    SCR_DSM_0027,
  },
  mixins: [commonfunc, groobeeUtil],
  props: {
    exhData: {
      type: Object,
      default () { return {} }
    },
    cnrData: {
      type: [Array, Object],
      default () { return [] }
    },
    exhCnrId: { // 코너 ID(메인 배너 ID)
      type: String,
      default: ''
    },
    exhCmptmtId: { // 구좌 ID
      type: String,
      default: ''
    },
    lgCtgrNo: {
      type: String,
      default: ''
    },
    sliceCnt: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    },
    isLazyLoading: {
      type: Boolean,
      default: true
    },
    accountIndex: {
      type: Number,
      default: null
    },
    pageKey: {
      type: String,
      default: ''
    },
    groobeeParam: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      hasError: false,
      dsFnc: ds,
      rndpgUrl: {},
      rndPgParams: {},
      urlTypeCd: '', // 전체보기 url 타입(추천셋, 판매 알림신청, 페이지 이동)
      titleYn: true,
      isActiveAccount: false,
      observer: {},
      hasMinHeight: this.accountIndex === 0 && this.exhData.exhMtrlTyCd === '07',
      groobeeRecmData: {},
      groobeeAllEposYn: true
    }
  },
  computed: {
    showHdCpy () {
      return this.hdcpy1 && this.pageKey !== 'diy'
    },
    // 타이틀 1
    hdcpy1 () {
      return this._.unescape(this.exhData.hdcpy1)
    },
    // 타이틀 2
    hdcpy2 () {
      return this._.unescape(this.exhData.hdcpy2)
    },
    // 서브타이틀
    subcpy () {
      return this._.unescape(this.exhData.subcpy)
    },
    // 카테고리 페이지 진입시 대카테고리 별로 구좌명 설정
    setLgCtgrNo () {
      const lgCtgrNo = this.$store.getters['ds/getLgCtgrNo']
      return lgCtgrNo || ''
    },
    // 홈메인 기획전 구좌 여부
    isExbtMtrl () {
      return (this.exhCnrId === 'C101' || this.pageKey === 'diy2') && this.exhData?.mtrls[0]?.exhMtrlTyCd === '12'
    },
    // 구좌별 정보
    ...mapGetters('ds', ['getMaterialInfo']),
    // 대카테고리 페이지명
    ...mapGetters('ds', ['getCtgrPgNm']),
    // 전체보기 노출 여부
    showRndBtn () {
      const info = this.getMaterialInfo(this.exhData.exhCmptmtId)
      switch (this.urlTypeCd) {
        case 'KV' : return info && info.showRndBtn
        case 'RC' : return info && info.showRndBtn
        case 'DI' : return info && info.showRndBtn && this.isNotEmpty(this.exhData.rndpgUrl)
        default : return false
      }
    },
    // 카테고리명 store 정보
    storeCtNm () {
      return this.$store.getters['ds/getCtgrPgNm']
    },
    // 로그인여부
    isLogined () {
      return !!this.$store.getters['session/getMbMngNo']
    },
    // 카테고리 링크 제목 노출여부
    getTitleYn () {
      if (this.exhCnrId === 'C101') {
        return true
      } else {
        return false
      }
    },
    pagePath () {
      return this.$route.path
    },
  },
  watch: {
    groobeeRecmData: {
      handler () {
        if (this.groobeeRecmData && this.groobeeRecmData.pdRecmNoList && this.groobeeRecmData.pdRecmNoList.length > 3) {
          this.isActiveAccount = true
        } else {
          this.isActiveAccount = false
        }
      },
      deep: true
    }
  },
  errorCaptured (err, instance, info) {
    console.log(`%c ※ 구좌 미노출  - ${this.hdcpy1} ${this.hdcpy2}`, 'color:#2F9C40;margin-top:1px', err)
    // 에러 구좌 테스트시 아래 코드 주석 후 확인
    if (this.isEmpty(this.exhData.exhCmptmtTyCd) && this.isNotEmpty(this.exhData.exbtNo)) {
      this.hasError = false // 기획전 상세 예외처리
    } else {
      this.hasError = true
    }
    return false
  },
  created () {
    const prdIdx = this.exhData.mtrls.findIndex((item) => { return item.exhMtrlTyCd === '02' })
    if (prdIdx >= 0) {
      const exhCmptmtId = this.exhData.exhCmptmtId
      const productObj = {}
      productObj.avtmBanrUseYn = this.exhData.avtmBanrUseYn
      productObj.mblBanrAvtmExprStdrCnt = this.exhData.mblBanrAvtmExprStdrCnt

      this.$store.commit('ds/setDsMaterials', { productObj, exhCmptmtId })
    }
  },
  async mounted () {
    this.accountLazyControl()
    // 추천셋 구좌 기본 정보 파라미터
    this.urlTypeCd = this.exhData.rndgpgUrlTypCd || ''
    if (this.isNotEmpty(this.urlTypeCd) && ['KV', 'RC'].includes(this.urlTypeCd)) {
      const exhData = {
        ...this.exhData,
        hdcpy1: this.exhData.hdcpy1 !== '_대카' ? this.exhData.hdcpy1 : this.storeCtNm
      }
      this.rndPgParams = ds.setDefaultParams(exhData)
      const productObj = {
        rndPgParams: this.rndPgParams,
        urlTypeCd: this.urlTypeCd
      }
      this.$store.commit('ds/setDsMaterials', { productObj, exhCmptmtId: this.exhData.exhCmptmtId })
    }
    this.$nextTick(() => {
      if (!this.lazyLoading) {
        this.$nuxt.$emit('cpltMount', true)
      }
    })

    // 홈메인 그루비 데이터 조회
    await this.setGroobee()
  },
  methods: {
    // 더보기 랜딩 페이지
    setRndPgUrl () {
      const pdInfo = this.getMaterialInfo(this.exhData.exhCmptmtId)
      const routerParams = pdInfo.rndPgParams || {}
      const moreParams = {
        id: 'C206',
        largeExhCtgrNo: this.$store.getters['ds/getLgCtgrNo']
      }
      if (this.pagePath?.includes('/bulkOrder')) {
        moreParams.cartType = 'bulkOrder'
      }

      if (this.isNotEmpty(this.urlTypeCd)) {
        if (this.urlTypeCd === 'DI' && this.exhData.rndpgUrl) { // 설정한 페이지 이동
          this.$router.push(this.exhData.rndpgUrl)
        } else {
          this.$store.dispatch('ds/persisted/updateRendingSet', routerParams).then(() => {
            if (['KV', 'RC'].includes(this.urlTypeCd)) { // KV : 전체보기, RC : 추천셋
              this.rndpgUrl = this.urlTypeCd === 'KV' ? 'ds-keybiz-pdNotification' : 'ds-recmd-id'
              this.$router.push({ name: this.rndpgUrl, params: { ...moreParams } })
            }
          })
        }
      }
    },
    // 홈메인 코너의 구좌 내 소재 타입별 데이터 전달
    bindArr (type) {
      const name = ds.getExhMtrlTyCd(type)
      const matchedArray = this.exhData.mtrls.find((item) => {
        return item[name]
      })
      return matchedArray ? matchedArray[name] : []
    },
    accountLazyControl () {
      let selectedAccount = ''
      if (!this.isLazyLoading) {
        this.isActiveAccount = true
        return
      }
      selectedAccount = document.getElementById(
        'account-' + this.exhData.exhCmptmtId
      )
      if (this.exhCnrId === 'C211') {
        selectedAccount = document.getElementById(
          'account-' + this.exhData.exhCmptmtId + '-' + this.exhData.exhMtrlNo
        )
      }

      if (this.isEmpty(selectedAccount)) {
        return
      }

      const options = {
        root: null,
        rootMargin: this.rootMargin,
        threshold: 0,
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isActiveAccount = true
            this.observer.unobserve(entry.target)
          }
        })
      }, options)

      if (selectedAccount instanceof Element) {
        this.observer?.observe(selectedAccount)
      }
    },
    minHeight (exhMtrlTyCd) {
      switch (exhMtrlTyCd) {
        case '01':
          if (this.exhCnrId === 'C101' && this.exhData?.mtrls[0]?.banner?.banrTyCd === '01') {
            return '508'
          }
          break
        case '02':
        case '12':
          return '500'
        default:
          return '100'
      }
    },
    resetFilterCheck () {
      sessionStorage.setItem('preFilterCheck', sessionStorage.getItem('filterCheck'))
      sessionStorage.setItem('filterCheck', [])
    },
    isLoading (val) {
      if (val === false) {
        this.hasMinHeight = val
      }
    },
    setGroobee () {
      if (this.exhData.aplMdiaPcomYn === 'Y') {
        this.groobeeAllEposYn = true

        // 홈메인
        if (this.exhCnrId === 'C101') {
          if (window.groobee) {
            window.groobee.lastAction = null
          }

          this.exhData.mtrls.forEach((item) => {
            if (item.product && item.product.exhMtrlRgMthdCd === '30' && item.product.rcmTyCd === '40') { // 그루비 추천 데이터 영역일 경우
              this.groobeeAllEposYn = false

              this.getGroobeeData(item.product.soltnInrkApiNm) // 그루비 추천 상품 데이터 조회
            }
          })
        } else {
          // 대카테고리
          this.cnrData.forEach((item) => {
            if (item.exhMtrlRgMthdCd === '30' && item.rcmTyCd === '40') { // 그루비 추천 데이터 영역일 경우
              this.groobeeAllEposYn = false

              this.setGroobeeCategory(this.groobeeParam) // 그루비 추천 상품 받기 전 groobee action 선행 호출
              this.getGroobeeData(item.soltnInrkApiNm) // 그루비 추천 상품 데이터 조회
            }
          })
        }
      }
    },
    async getGroobeeData (campaignKey) {
      this.groobeeRecmData = await this.getGroobeeRecommendProd(campaignKey)
    }
  }
}
